import React, { Component } from "react";
import PropTypes from "prop-types";

import { isDefined, isNotDefined, noop } from "../utils";
import { terminate, saveNodeType, isHoverForInteractiveType } from "./utils";
import EachFibonacciFan from "./wrapper/EachFibonacciFan";
import MouseLocationIndicator from "./components/MouseLocationIndicator";
import HoverTextNearMouse from "./components/HoverTextNearMouse";

class FibonacciFan extends Component {
  constructor(props) {
    super(props);

    this.handleStart = this.handleStart.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleDrawFan = this.handleDrawFan.bind(this);

    this.handleDrag = this.handleDrag.bind(this);
    this.handleDragComplete = this.handleDragComplete.bind(this);

    this.terminate = terminate.bind(this);
    this.getSelectionState = isHoverForInteractiveType("fans").bind(this);

    this.saveNodeType = saveNodeType.bind(this);
    this.nodes = [];

    this.state = {
      current: null,
      override: null,
    };
  }

  handleDrawFan(xyValue) {
    const { current } = this.state;
    if (isDefined(current) && isDefined(current.x1)) {
      this.mouseMoved = true;
      this.setState({
        current: {
          ...current,
          x2: xyValue[0],
          y2: xyValue[1],
        },
      });
    }
  }

  handleDrag(index, xy) {
    this.setState({
      override: {
        index,
        ...xy,
      },
    });
  }

  handleDragComplete(moreProps) {
    const { fans } = this.props;
    const { override } = this.state;
    if (isDefined(override)) {
      const { index, ...rest } = override;

      const newFans = fans.map((each, idx) =>
        idx === index ? { ...each, ...rest, selected: true } : each,
      );
      this.setState(
        {
          override: null,
        },
        () => {
          this.props.onComplete(newFans, moreProps);
        },
      );
    }
  }

  handleStart(xyValue, moreProps) {
    const { current } = this.state;
    if (isNotDefined(current) || isNotDefined(current.x1)) {
      this.mouseMoved = false;
      this.setState(
        {
          current: {
            x1: xyValue[0],
            y1: xyValue[1],
            x2: null,
            y2: null,
          },
        },
        () => {
          this.props.onStart(moreProps);
        },
      );
    }
  }

  handleEnd(xyValue, moreProps, e) {
    const { fans, appearance } = this.props;
    const { current } = this.state;

    if (this.mouseMoved && isDefined(current) && isDefined(current.x1)) {
      const currentAppearance = appearance;

      const newFans = fans.concat({
        ...current,
        x2: xyValue[0],
        y2: xyValue[1],
        selected: true,
        appearance: currentAppearance,
      });

      this.setState(
        {
          current: null,
        },
        () => {
          this.props.onComplete(newFans, moreProps, e);
        },
      );
    }
  }

  render() {
    const { current, override } = this.state;
    const { fans, appearance, enabled, hoverText } = this.props;
    const {
      currentPositionStroke,
      currentPositionOpacity,
      currentPositionStrokeWidth,
      currentPositionRadius,
    } = this.props;

    const overrideIndex = isDefined(override) ? override.index : null;
    const hoverTextWithDefaults = {
      ...FibonacciFan.defaultProps.hoverText,
      ...hoverText,
    };

    const currentFan =
      isDefined(current) && isDefined(current.x2) ? (
        <EachFibonacciFan
          interactive={false}
          appearance={appearance}
          hoverText={hoverTextWithDefaults}
          {...current}
        />
      ) : null;

    return (
      <g>
        {fans.map((each, idx) => {
          const eachAppearance = isDefined(each.appearance)
            ? { ...appearance, ...each.appearance }
            : appearance;

          const eachHoverText = isDefined(each.hoverText)
            ? { ...hoverTextWithDefaults, ...each.hoverText }
            : hoverTextWithDefaults;

          return (
            <EachFibonacciFan
              key={idx}
              ref={this.saveNodeType(idx)}
              index={idx}
              selected={each.selected}
              {...(idx === overrideIndex ? override : each)}
              hoverText={eachHoverText}
              appearance={eachAppearance}
              onDrag={this.handleDrag}
              onDragComplete={this.handleDragComplete}
            />
          );
        })}
        {currentFan}
        <MouseLocationIndicator
          enabled={enabled}
          snap={false}
          r={currentPositionRadius}
          stroke={currentPositionStroke}
          opacity={currentPositionOpacity}
          strokeWidth={currentPositionStrokeWidth}
          onMouseDown={this.handleStart}
          onClick={this.handleEnd}
          onMouseMove={this.handleDrawFan}
          data-evo-id="interactive-fibonacci-fan"
        />
      </g>
    );
  }
}

FibonacciFan.propTypes = {
  enabled: PropTypes.bool.isRequired,

  onStart: PropTypes.func,
  onComplete: PropTypes.func,
  onSelect: PropTypes.func,

  hoverText: PropTypes.object.isRequired,

  currentPositionStroke: PropTypes.string,
  currentPositionStrokeWidth: PropTypes.number,
  currentPositionOpacity: PropTypes.number,
  currentPositionRadius: PropTypes.number,

  fans: PropTypes.array.isRequired,

  appearance: PropTypes.shape({
    stroke: PropTypes.oneOfType([
      PropTypes.shape({
        color: PropTypes.string,
        dash: PropTypes.string,
        width: PropTypes.number,
        opacity: PropTypes.number,
      }),
      PropTypes.string,
    ]),
    font: PropTypes.shape({
      fontFamily: PropTypes.string,
      fontSize: PropTypes.number,
      color: PropTypes.string,
    }),
  }).isRequired,
};

FibonacciFan.defaultProps = {
  fans: [],
  onStart: noop,
  onComplete: noop,
  onSelect: noop,

  currentPositionStroke: "#2196F3",
  currentPositionOpacity: 1,
  currentPositionStrokeWidth: 2,
  currentPositionRadius: 4,

  hoverText: {
    ...HoverTextNearMouse.defaultProps,
    enable: false,
    bgHeight: "auto",
    bgWidth: "auto",
    text: "Clique e arraste para criar Leque Fibonacci",
    selectedText: "",
  },
};

export default FibonacciFan;
